import { Component, OnInit, Input } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { CustCard_4 } from "src/classes/Customers/CustCard_4";


@Component({
    selector: "app-custcardview4",
    templateUrl: "./custcardview4.component.html",
    styleUrls: ["./custcardview4.component.css"],
    providers: [HttpServiceCustomer]
})
export class Custcardview4Component implements OnInit {
    customerin: CustomerIn = new CustomerIn();
    custcard_4: CustCard_4 = new CustCard_4();

    @Input() customerId: number = 0;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private logger: NGXLogger
    ) { }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        // Get custcard_4 data
        this.httpServiceCustomer.getCustCard_4(this.customerin)
            .subscribe((res: CustCard_4) => {
                this.custcard_4 = res;
                console.log("registrationDate from custcard_4:" + this.custcard_4.registrationDate);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }
}
